export default __webpack_public_path__ + "static/media/purpose.66070588.svg";